/**
 * ConfirmSaveModal Component
 * Confirmation dialog before saving policy changes
 */

import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface ConfirmSaveModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export function ConfirmSaveModal({ isOpen, onConfirm, onCancel, isSaving }: ConfirmSaveModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Confirmar cambios" size="sm">
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Estas seguro de guardar los cambios? Los cambios afectaran el motor de credito.
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onCancel} disabled={isSaving}>
            Cancelar
          </Button>
          <Button variant="primary" size="sm" onClick={onConfirm} isLoading={isSaving}>
            Confirmar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
